import { factory } from '@repo-level/core-front';

export interface IUserStorageItem<Info = object> {
  identifier: string;
  info: Info;
  createdAt: string;
  updatedAt: string;
}

export const userStorageItems = factory(
  (r) => () =>
    r<{ data: IUserStorageItem[] } | IUserStorageItem[]>(
      'get',
      'user_storage_items'
    )
);

export const setUserStorageItems = factory(
  (r) => (data: Pick<IUserStorageItem, 'identifier' | 'info'>[]) =>
    r<null>('post', 'user_storage_items', { data })
);

export const deleteUserStorageItems = factory(
  (r) => (data: string[]) =>
    r<null>('post', 'user_storage_items/delete', { data })
);
